import { render, staticRenderFns } from "./OrdersTableOrderCreative.vue?vue&type=template&id=2b965070&scoped=true&"
import script from "./OrdersTableOrderCreative.vue?vue&type=script&lang=js&"
export * from "./OrdersTableOrderCreative.vue?vue&type=script&lang=js&"
import style0 from "./OrdersTableOrderCreative.vue?vue&type=style&index=0&id=2b965070&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b965070",
  null
  
)

export default component.exports